import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import {
  Button,
  Table,
  Row,
  Col,
  Modal,
  Form,
  Input,
  notification,
} from "antd";
import { cerateOrganization, getOrganizations } from "../../utils/api";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { LoadingOutlined, RightOutlined } from "@ant-design/icons";
import AddUserCode from "./AddUserCode";

import "./Organization.css";

const antIcon = (
  <LoadingOutlined style={{ color: "white", fontSize: 32 }} spin />
);

function Organization({ navStore }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [modalError, setModalError] = useState("");
  const [name, setName] = useState("");

  const [organizations, setOrganizations] = useState([]);
  const [organizationMapping, setOrganizationMapping] = useState(null);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button
          style={{ float: "right" }}
          onClick={() => orgSelected(record.id)}
        >
          <RightOutlined />
        </Button>
      ),
    },
  ];

  const organizationMappingColumns = [
    {
      title: "User Id",
      dataIndex: "user_id",
      key: "user_id",
    },
  ];

  const refreshOrg = () => {
    getOrganizations().then((res) => {
      const organizations = res.map((x) => {
        const id = x.id;
        const name = x.name;
        return {
          id,
          name,
        };
      });
      setOrganizations(organizations);
      setLoading(false);
    });
  };

  useEffect(() => {
    navStore.selectedKey = "2";
    setLoading(true);
    refreshOrg();
  }, []);

  useEffect(() => {
    navStore.selectedKey = "2";
    if (!selectedOrg) {
      return;
    }
  }, [selectedOrg]);

  const orgSelected = (org) => {
    setSelectedOrg(org.id);
  };

  const showModal = () => {
    setName("");
    setModalError("");
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      setSubmitting(true);
      await cerateOrganization({ name: name });
      notification.open({
        message: "Organization added",
        description: "Organization added successfully",
      });
      refreshOrg();
      setIsModalVisible(false);
      // refresh org
    } catch (e) {
      setModalError(e.response.data.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="Organization">
      <Modal
        title={`Add Organization`}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Create"
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submitting}
            onClick={handleOk}
          >
            Create
          </Button>,
        ]}
      >
        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="name"
            name="name"
            rules={[{ required: true, message: "Please enter a name" }]}
          >
            <Input value={name} onChange={(e) => setName(e.target.value)} />

            {modalError && (
              <div className="Organization__error">{modalError}</div>
            )}
          </Form.Item>
        </Form>
      </Modal>

      {loading && <LoadingSpinner />}
      {!loading && (
        <Row>
          <Col md={12}>
            <div className="seperator">
              <Button
                type="primary"
                style={{ float: "right" }}
                onClick={showModal}
              >
                Add Organization
              </Button>
            </div>

            <Table
              dataSource={organizations}
              columns={columns}
              rowClassName={(record, index) => {
                if (record.id === selectedOrg) {
                  return "selected";
                } else {
                  return "";
                }
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => orgSelected(record),
                };
              }}
            />
          </Col>
          <Col md={11} style={{ marginLeft: "2em" }}>
            {!selectedOrg && (
              <div style={{ textAlign: "center", marginTop: "5em" }}>
                Please select an organization
              </div>
            )}
            {selectedOrg && (
              <AddUserCode selectedOrg={selectedOrg}></AddUserCode>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
}

export default observer(Organization);
